"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreadMessage = exports.REACTIONS = exports.EThreadMessageSubtype = exports.EThreadMessageEvents = exports.EMedium = void 0;
const Common_1 = require("./Common");
const Thread_1 = require("./Thread");
const CloudFile_1 = require("./CloudFile");
const Contact_1 = require("./Contact");
const index_1 = require("../index");
var EMedium;
(function (EMedium) {
    EMedium["EMAIL"] = "email";
    EMedium["CHAT"] = "chat";
    EMedium["TEXT"] = "text";
    EMedium["NOTE"] = "note";
    EMedium["WEB"] = "web";
    EMedium["ARCHIVE"] = "archive";
    EMedium["NONE"] = "";
})(EMedium || (exports.EMedium = EMedium = {}));
var EThreadMessageEvents;
(function (EThreadMessageEvents) {
    EThreadMessageEvents["OPEN"] = "o";
    EThreadMessageEvents["CLICK"] = "c";
    EThreadMessageEvents["UNSUBSCRIBE"] = "u";
    EThreadMessageEvents["DELIVERED"] = "d";
    EThreadMessageEvents["SENT"] = "s";
    EThreadMessageEvents["BOUNCE"] = "b";
    EThreadMessageEvents["FAILED"] = "f";
})(EThreadMessageEvents || (exports.EThreadMessageEvents = EThreadMessageEvents = {}));
var EThreadMessageSubtype;
(function (EThreadMessageSubtype) {
    EThreadMessageSubtype["DIRECT"] = "direct";
})(EThreadMessageSubtype || (exports.EThreadMessageSubtype = EThreadMessageSubtype = {}));
exports.REACTIONS = ['thumb-up']; //,'thumb-down','heart','check'];
class ThreadMessage extends Thread_1.Thread {
    unread = false;
    message = '';
    messageHtml = '';
    note = '';
    draft = false;
    results = {};
    domain = '';
    fromEmail = '';
    cc = [];
    bcc = [];
    signature = false;
    replyingTo = null;
    forward = false;
    data = [];
    document_id = null;
    tRef = null;
    skipTracking = false;
    subtype;
    files = new index_1.ChildArray();
    reactions = {};
    mentions = [];
    _m = ['date', 'creator', 'medium', 'subject', 'summary', 'inbound'];
    _s = ['filters', 'medium', 'unread', 'inbound', 'active', 'cc', 'object', 'html', 'recipients', 'contact', 'creator', 'subject', 'summary', 'unassigned'];
    get unassigned() {
        return (!this.agents?.length && !this.followers?.length && !this.roles?.length) ? true : false;
    }
    async loadAll(opts, stack, p) {
        opts.properties = (opts.properties !== undefined) ? opts.properties : Object.getOwnPropertyNames(this);
        opts.properties.splice(opts.properties.findIndex(p => p === 'activity'), 1);
        await super.loadAll(opts, stack, p);
    }
    constructor(data, olMap) {
        super(data, olMap, 'threadsmsgs', 32);
        (0, Common_1.setObjectProperties)(this, data, olMap, ThreadMessage);
        if (this.object && olMap) {
            this.object = (0, index_1.loadObject)(this.object, { olm: olMap || index_1.olm });
            this.contact = (0, index_1.loadObject)(this.contact, { olm: olMap || index_1.olm });
            if (this.object && this.contact && !(this.object instanceof Contact_1.Contact)) {
                this.object.contact = this.contact;
            }
        }
    }
    async markRead() {
        if (this.id) {
            this.unread = false;
            await super.markRead();
            await this.save();
        }
    }
    toJSON() {
        let r = super.toJSON();
        if (r?.html) {
            const encoder = new TextEncoder();
            const byteArray = encoder.encode(r.html);
            if (byteArray.length > 1027604) {
                console.log(`TOO BIG! SUBJECT: ${r.subject}`, new Date(r.date));
                r.html = truncateEmailHtml(r.html, 1027604);
            }
        }
        return r;
    }
    async save(parent) {
        if (!this.id) {
            this.setID();
        }
        if (this.object?._docRef) {
            this.ref = this.object._docRef;
        }
        if (this.contact?._docRef) {
            this.contactRef = this.contact._docRef;
        }
        if (!this.ref) {
            throw `Cannot Save! No reference set on message.`;
        }
        if (this.gmail_id) {
            this.third_party = this.gmail_id;
        }
        this.date = this.date || Date.now();
        if (parent?._docRef) {
            if (parent._type !== 'threads') {
                throw `Cannot Save! Must pass in thread as parent when saving a message.`;
            }
            this.tRef = parent._docRef;
            this._docRef = this.tRef.parent.parent.collection(this._type).doc(this.id);
        }
        if (!this._docRef) {
            throw `Cannot save ${this._type}! No document reference.`;
        }
        else if (!this.tRef) {
            throw `Cannot save ${this._type}! No thread reference.`;
        }
        else {
            this._new = !this._exists;
            this._docRef.set(this.toJSON());
            this._exists = true;
        }
        if (this.files?.length) {
            await Promise.all(this.files.map((file) => {
                file = new CloudFile_1.CloudFile(file);
                if (file?.id && !file._exists) {
                    return file.save(this);
                }
            }));
        }
    }
}
exports.ThreadMessage = ThreadMessage;
index_1.olm.threadsmsgs = (ref, map) => {
    return new ThreadMessage(ref, map);
};
function truncateEmailHtml(html, maxBytes) {
    const encoder = new TextEncoder();
    const sizeOf = (str) => encoder.encode(str).length;
    console.log(`Starting truncateEmailHtml: initial size ${sizeOf(html)} bytes, limit ${maxBytes} bytes`);
    if (sizeOf(html) <= maxBytes) {
        console.log(`→ Under limit, returning original HTML`);
        return html;
    }
    const quotes = [...html.matchAll(/<blockquote\b[^>]*>/gi)];
    console.log(`Found ${quotes.length} <blockquote> markers`);
    let cutHtml = html;
    while (sizeOf(cutHtml) > maxBytes && quotes.length) {
        const idx = Math.floor(quotes.length / 2);
        //non-null assertion here.
        const pos = quotes[idx].index;
        // console.log(` Trimming at blockquote #${idx + 1}/${quotes.length} (byte pos roughly), size before cut ${sizeOf(cutHtml)} bytes`);
        cutHtml = cutHtml.slice(0, pos);
        quotes.splice(idx, 1);
        // console.log(`  → size after cut ${sizeOf(cutHtml)} bytes`);
    }
    if (sizeOf(cutHtml) <= maxBytes) {
        console.log(`→ Successful blockquote truncation: final size ${sizeOf(cutHtml)} bytes`);
        return (cutHtml + '<p><em>Message truncated. Please refer to earlier messages for full context.</em></p>');
    }
    // console.log(`Blockquote chop didn’t suffice, entering fallback halving (current size ${sizeOf(cutHtml)} bytes)`);
    let fallback = cutHtml;
    let iterations = 0;
    while (sizeOf(fallback) > maxBytes) {
        fallback = fallback.slice(0, Math.floor(fallback.length / 2));
        iterations++;
        // console.log(`Halving iteration ${iterations}: size now ${sizeOf(fallback)} bytes`);
    }
    console.log(`→ Finished halving after ${iterations} iterations; final size ${sizeOf(fallback)} bytes`);
    return (fallback + '<p><em>Message truncated due to size. Please refer to earlier messages for full context.</em></p>');
}
